(function (angular) {
    'use strict';

    angular.module('profiles')

        /**
         *
         */
        .factory('audiencesService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8002';
                    var fac = {
                        getAudiences: getAudiences,
                        getAudience: getAudience,
                        createAudience: createAudience,
                        updateAudience: updateAudience,
                        deleteAudience: deleteAudience,
                    };

                    return fac;

                    /**
                     * GET "/apispaces/{id}/audiences"
                     * @param {string} id - the api space Id
                     */
                    function getAudiences(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/audiences")
                            .then(getAudiencesComplete)
                            .catch(getAudiencesFailed);

                        function getAudiencesComplete(response) {
                            return response.data;
                        }

                        function getAudiencesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{id}/audiences/{searchId}"
                     * @param {string} id - the api space Id
                     * @param {string} searchId - the profile Id
                     */
                    function getAudience(id, searchId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/audiences/" + encodeURIComponent(searchId))
                            .then(getAudienceComplete)
                            .catch(getAudienceFailed);

                        function getAudienceComplete(response) {
                            return response.data;
                        }

                        function getAudienceFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }
                    /**
                     * POST "/apispaces/{id}/audiences/"
                     * @param {string} id - the api space Id
                     * @param {string} search - data of search to update
                     */
                    function createAudience(id, search) {

                        return $http.post(urlBase + "/apispaces/" + id + "/audiences", search)
                            .then(createAudienceComplete)
                            .catch(createAudienceFailed);

                        function createAudienceComplete(response) {
                            return response.data;
                        }

                        function createAudienceFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/audiences/{searchId}"
                     * @param {string} id - the api space Id
                     * @param {string} search - data of search to update
                     */
                    function updateAudience(id, search) {

                        return $http.put(urlBase + "/apispaces/" + id + "/audiences/" + encodeURIComponent(search.id), search)
                            .then(updateAudienceComplete)
                            .catch(updateAudienceFailed);

                        function updateAudienceComplete(response) {
                            return response.data;
                        }

                        function updateAudienceFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * DELETE "/apispaces/{id}/audiences/{searchId}"
                     * @param {string} id - the api space Id
                     * @param {string} searchId - the profile Id
                     */
                    function deleteAudience(id, searchId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/audiences/" + searchId)
                            .then(deleteAudienceComplete)
                            .catch(deleteAudienceFailed);

                        function deleteAudienceComplete(response) {
                            return response.data;
                        }

                        function deleteAudienceFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);
})(window.angular);
